<template>
  <main style="padding-top: 50px">
    <TelHeader style="width: 100%; height: 50px; top: 0; left: 0" />
    <telp-intv-user-card
      :userProfile="userProfile"
      :telpSampleList="telpSampleList"
    />
    <div>
      <div class="row q-mb-md">
        <q-btn-toggle
          style="margin: auto"
          v-model="county"
          no-caps
          rounded
          dense
          toggle-color="primary"
          text-color="grey-6"
          :options="hangZhouCounties"
        />
        <q-btn-toggle
          style="margin: auto"
          v-model="filterIndex"
          toggle-color="primary"
          class="q-mx-lg q-px-sm"
          flat
          dense
          text-color="grey-6"
          size="md"
          @input="filterSample"
          :options="[
            {
              label: `全部 (${telpSampleList.length})`,
              value: 'all',
            },
            {
              label: `未处理 (${noneSample.length})`,
              value: 'noneSample',
            },
            {
              label: `有效样本 (${checkedSample.length})`,
              value: 'checkedSample',
            },
            {
              label: `无效样本 (${invalidSample.length})`,
              value: 'invalidSample',
            },
            {
              label: `无法确认 (${uncheckedSample.length})`,
              value: 'uncheckedSample',
            },
          ]"
        />
      </div>
      <q-virtual-scroll
        style="max-height: 75vh; max-width: 1200px; margin: auto"
        class="full-height q-ma-lg"
        :items="currentSamples"
      >
        <template v-slot="{ item, index }">
          <q-item v-if="item.detail.tel" :key="index" dense>
            <telp-inv-sample-list :sample="item" />
          </q-item>
        </template>
      </q-virtual-scroll>
    </div>
  </main>
</template>

<script>
import { getUserProfile } from "../../api/endpoints/auth/getUserProfile";
import { getAllTelpIntvSampleList } from "../../api/endpoints/sample-telephone-interview/getAllTelpIntvSampleList";
import { styleLog } from "../../utils/style-log";
import { SAMPLE_TELP_INTV_CHANGED } from "@/bus/admin.events";
import { EventBus } from "../../bus";

export default {
  data() {
    return {
      userProfile: {},
      telpSampleList: [],
      samples: [],
      currentSamples: [],
      filterIndex: "all",
      county: "330102",
      hangZhouCounties: [
        {
          label: "上城区",
          value: "330102",
        },
        {
          label: "拱墅区",
          value: "330105",
        },

        {
          label: "西湖区",
          value: "330106",
        },
        {
          label: "滨江区",
          value: "330108",
        },
        {
          label: "萧山区",
          value: "330109",
        },
        {
          label: "余杭区",
          value: "330110",
        },
        {
          label: "富阳区",
          value: "330111",
        },
        {
          label: "临安区",
          value: "330112",
        },
        {
          label: "临平区",
          value: "330113",
        },

        {
          label: "钱塘区",
          value: "330114",
        },

        {
          label: "桐庐县",
          value: "330122",
        },
        {
          label: "淳安县",
          value: "330127",
        },

        {
          label: "建德市",
          value: "330182",
        },
      ],
    };
  },
  components: {
    TelHeader: () => import("./Header"),
    TelpInvSampleList: () => import("./TelpInvSampleList.vue"),
    TelpIntvUserCard: () => import("./TelpIntvUserCard.vue"),
  },

  mounted() {
    // console.log(this.userDetail);
    this.getUserProfile();
    EventBus.$on(SAMPLE_TELP_INTV_CHANGED, this.getAllTelpIntvSampleList);
  },
  watch: {
    samples: {
      immediate: true,
      handler() {
        this.telpSampleList = this.samples.filter((sample) => {
          return sample.detail.tel;
        });
        this.filterSample();
      },
    },
    county: {
      immediate: false,
      handler() {
        this.getAllTelpIntvSampleList(this.county)
      }
    }
  },
  computed: {
    invalidSample() {
      return this.telpSampleList.filter((sample) => {
        if (sample.telp_intv && sample.telp_intv.status) {
          return sample.telp_intv.status === "invalid";
        }
      });
    },
    checkedSample() {
      return this.telpSampleList.filter((sample) => {
        if (sample.telp_intv && sample.telp_intv.status) {
          return sample.telp_intv.status === "checked";
        }
      });
    },
    uncheckedSample() {
      return this.telpSampleList.filter((sample) => {
        if (sample.telp_intv && sample.telp_intv.status) {
          return sample.telp_intv.status === "unchecked";
        }
      });
    },
    noneSample() {
      return this.telpSampleList.filter((sample) => {
        return sample.telp_intv === null || sample.telp_intv.status === "";
      });
    },
  },
  methods: {
    async getUserProfile() {
      try {
        const res = await getUserProfile(false, true);
        // console.log(res.group.id);
        this.userProfile = res;
        if (res.status || res.error) {
          this.$q.notify({
            type: "danger",
            message: res.detail || res.message,
          });
        } else {
          await this.getAllTelpIntvSampleList();
        }
      } catch (error) {
        styleLog.dangerPrefix(error);
        this.$q.notify({ type: "danger", message: "获取用户详情失败" });
      }
    },

    async getAllTelpIntvSampleList() {
      try {
        const res = await getAllTelpIntvSampleList(this.county);
        // console.log(res);
        this.samples = res;
      } catch (error) {
        styleLog.dangerPrefix(error);
        this.$q.notify({ type: "danger", message: "获取样本列表" });
      }
    },

    filterSample() {
      // console.log("filterSample");
      switch (this.filterIndex) {
        case "all":
          this.currentSamples = this.telpSampleList;
          // console.log(this.currentSamples);
          break;
        case "noneSample":
          this.currentSamples = this.noneSample;
          // console.log(this.currentSamples);
          break;
        case "checkedSample":
          this.currentSamples = this.checkedSample;
          // console.log(this.currentSamples);
          break;
        case "invalidSample":
          this.currentSamples = this.invalidSample;
          // console.log(this.currentSamples);
          break;
        case "uncheckedSample":
          this.currentSamples = this.uncheckedSample;
          // console.log(this.currentSamples);
          break;
      }
    },
  },
};
</script>
